import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapList'
})
export class MapListPipe implements PipeTransform {
  transform(map: Map<any, any>, args: any[]): any {
    const items: any[] = [];
    map.forEach((value: any, key: any) => {
      items.push({ label: value, value: key });
    });
    return items;
  }
}
